module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "data-pdf-bookmark": "Part III. Meet the Team . . .",
      "data-type": "part",
      "epub:type": "part",
      "id": "d1e1418"
    }
  }, [_c('h1', {
    staticClass: "PartTitlept"
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Team . . .")])]), _c('h1', {
    staticClass: "PartTitlept"
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVERYONE WANTS TO BELONG TO THE CLUBS!")])]), _c('figure', {
    staticClass: "Illustrationholderill customimage"
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "Club.png",
      "src": "Club.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1h1"
  }, [_vm._v("Meet the Clubs . . .")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("BUFORD hails from down the swamp. Some say he’s just a good ol’ boy, but he’s got him one mean tongue. Folks go green when they see")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("TOAD MAN!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Buford Calhoun")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Loxahatchee, Florida")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("JAMAL takes a licking and keeps on ticking. Shoot him, stab him, burn him, and he’ll be back for more. No one can stop ")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("STUNTMAN!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Jamal Norwood")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Inglewood, California")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("The best-laid plans develop hiccups when PAUL’s around. He makes men cry “Gesundheit,” and women cry, “Oh, yes, oh, yes, oh, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("SPASM!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Paul Blackwell")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Denver, Colorado")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("PEARL knows all the secrets of the sea, and speaks the language of the dolphins and the whales. Go deep with")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("DIVER!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Pearl Olsen")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Honolulu, Hawaii")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("TOM soars above his ancient lands on proud, strong wings, watching, guarding, remembering. Look, up in the sky, it’s")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("BRAVE HAWK!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Tom Diedrich")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Benson, Arizona")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("HALEY floats like a butterfly and hits like a pile driver. Light as a feather in the wind, hard as ton of steel, that’s our")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("JADE BLOSSOM!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Haley Mok")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Redondo Beach, California")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("THADDEUS will knock you down, roll over you, and save your soul. Cry hallelujah, brother, and pray you don’t get in the way of")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("HOLY ROLLER!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Rev. Thaddeus Wintergreen")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Natchez, Mississippi")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa071a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part03.vue
// module id = 78
// module chunks = 0